import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import { Cancel, ArrowBack, ShoppingCart } from '@mui/icons-material';

export const SubscriptionCancel: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToApp = () => {
    navigate('/');
  };

  const handleTryAgain = () => {
    navigate('/pricing');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
      }}
    >
      <Card sx={{ maxWidth: 500, width: '100%' }}>
        <CardContent sx={{ textAlign: 'center', p: 4 }}>
          <Cancel
            sx={{
              fontSize: 80,
              color: 'warning.main',
              mb: 3,
            }}
          />
          
          <Typography variant="h4" gutterBottom color="warning.main">
            Payment Canceled
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your payment was canceled. No charges have been made to your account.
          </Typography>

          <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="body2">
              <strong>Need help?</strong>
              <br />
              • Contact our support team if you encountered any issues
              <br />
              • Check your payment method and try again
              <br />
              • Review our pricing plans to find the right option
              <br />
              • You can start a free trial to explore our features
            </Typography>
          </Alert>

          <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={handleBackToApp}
              fullWidth
            >
              Back to Application
            </Button>
            
            <Button
              variant="contained"
              startIcon={<ShoppingCart />}
              onClick={handleTryAgain}
              fullWidth
            >
              Try Again
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
